/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getVitals } from 'app/entities/vitals/vitals.reducer';
import { getEntities as getNurses } from 'app/entities/nurse/nurse.reducer';
import { getEntities as getTreatmentCycles } from 'app/entities/treatment-cycle/treatment-cycle.reducer';
import { getEntities as getTreatmentRadiations } from 'app/entities/treatment-radiation/treatment-radiation.reducer';
import { createEntity, getEntity, reset, updateEntity } from './treatment-session-vitals.reducer';

export const TreatmentSessionVitalsUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const vitals = useAppSelector(state => state.vitals.entities);
  const nurses = useAppSelector(state => state.nurse.entities);
  const treatmentCycles = useAppSelector(state => state.treatmentCycle.entities);
  const treatmentRadiations = useAppSelector(state => state.treatmentRadiation.entities);
  const treatmentSessionVitalsEntity = useAppSelector(state => state.treatmentSessionVitals.entity);
  const loading = useAppSelector(state => state.treatmentSessionVitals.loading);
  const updating = useAppSelector(state => state.treatmentSessionVitals.updating);
  const updateSuccess = useAppSelector(state => state.treatmentSessionVitals.updateSuccess);

  const handleClose = () => {
    navigate(`/treatment-session-vitals${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getVitals({}));
    dispatch(getNurses({}));
    dispatch(getTreatmentCycles({}));
    dispatch(getTreatmentRadiations({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }

    const entity = {
      ...treatmentSessionVitalsEntity,
      ...values,
      vitals: vitals.find(it => it.id.toString() === values.vitals?.toString()),
      recordingNurse: nurses.find(it => it.id.toString() === values.recordingNurse?.toString()),
      validatingNurse: nurses.find(it => it.id.toString() === values.validatingNurse?.toString()),
      cycle: treatmentCycles.find(it => it.id.toString() === values.cycle?.toString()),
      radiationSession: treatmentRadiations.find(it => it.id.toString() === values.radiationSession?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...treatmentSessionVitalsEntity,
          vitals: treatmentSessionVitalsEntity?.vitals?.id,
          recordingNurse: treatmentSessionVitalsEntity?.recordingNurse?.id,
          validatingNurse: treatmentSessionVitalsEntity?.validatingNurse?.id,
          cycle: treatmentSessionVitalsEntity?.cycle?.id,
          radiationSession: treatmentSessionVitalsEntity?.radiationSession?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.treatmentSessionVitals.home.createOrEditLabel" data-cy="TreatmentSessionVitalsCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.treatmentSessionVitals.home.createOrEditLabel">
              Create or edit a TreatmentSessionVitals
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="treatment-session-vitals-id"
                  label={translate('tinyMedicRestApp.treatmentSessionVitals.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.treatmentSessionVitals.active')}
                id="treatment-session-vitals-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.treatmentSessionVitals.cursor')}
                id="treatment-session-vitals-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.treatmentSessionVitals.lastUpdated')}
                id="treatment-session-vitals-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.treatmentSessionVitals.microSec')}
                id="treatment-session-vitals-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.treatmentSessionVitals.timestampEntry')}
                id="treatment-session-vitals-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.treatmentSessionVitals.notes')}
                id="treatment-session-vitals-notes"
                name="notes"
                data-cy="notes"
                type="text"
              />
              <ValidatedField
                id="treatment-session-vitals-vitals"
                name="vitals"
                data-cy="vitals"
                label={translate('tinyMedicRestApp.treatmentSessionVitals.vitals')}
                type="select"
              >
                <option value="" key="0" />
                {vitals
                  ? vitals.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="treatment-session-vitals-recordingNurse"
                name="recordingNurse"
                data-cy="recordingNurse"
                label={translate('tinyMedicRestApp.treatmentSessionVitals.recordingNurse')}
                type="select"
              >
                <option value="" key="0" />
                {nurses
                  ? nurses.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="treatment-session-vitals-validatingNurse"
                name="validatingNurse"
                data-cy="validatingNurse"
                label={translate('tinyMedicRestApp.treatmentSessionVitals.validatingNurse')}
                type="select"
              >
                <option value="" key="0" />
                {nurses
                  ? nurses.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="treatment-session-vitals-cycle"
                name="cycle"
                data-cy="cycle"
                label={translate('tinyMedicRestApp.treatmentSessionVitals.cycle')}
                type="select"
              >
                <option value="" key="0" />
                {treatmentCycles
                  ? treatmentCycles.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="treatment-session-vitals-radiationSession"
                name="radiationSession"
                data-cy="radiationSession"
                label={translate('tinyMedicRestApp.treatmentSessionVitals.radiationSession')}
                type="select"
              >
                <option value="" key="0" />
                {treatmentRadiations
                  ? treatmentRadiations.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/treatment-session-vitals" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default TreatmentSessionVitalsUpdate;
